<template>
  <BContainer
    class="mb-5"
    fluid
  >
    <div class="d-flex justify-content-end mb-0 pb-0">
      <BBreadcrumb
        v-if="$route.meta.breadcrumb"
        :items="$route.meta.breadcrumb || []"
      />
    </div>

    <BRow
      class="mt-3"
    >
      <BCol
        cols="12"
      >
        <BCard>
          <ValidationObserver
            ref="formChangePassword"
          >
            <form
              novalidate
              role="form"
              @submit.prevent
            >
              <BRow>

                <BCol
                  cols="12"
                  md="4"
                >
                  <ValidationProvider
                    v-slot="{ errors }"
                    vid="current_password"
                    name="current password"
                    rules="required"
                  >
                    <BFormGroup
                      label="Current Password"
                      label-for="current_password"
                      label-class="font-weight-bold"
                      class="mb-2"
                    >
                      <BInputGroup
                        :class="errors.length > 0 ? 'is-invalid' : null"
                      >
                        <BFormInput
                          id="current_password"
                          v-model="credentials.current_password"
                          placeholder="enter current password"
                          autocomplete="off"
                          :type="currentPasswordType"
                          :state="errors.length > 0 ? false : null"
                          :disabled="state.busy"
                        />
                        <BInputGroupAppend>
                          <BButton
                            class="pl-2 pr-1 text-dark input-icon"
                            variant="warning"
                            :disabled="state.busy"
                            @click.prevent="toggleCurrentPassword"
                          >
                            <i
                              v-if="state.current_password_visible"
                              class="ri-eye-line h5"
                            />
                            <i
                              v-else
                              class="ri-eye-off-line h5"
                            />
                          </BButton>
                        </BInputGroupAppend>
                      </BInputGroup>
                      <div
                        v-if="errors.length > 0"
                        class="invalid-feedback"
                      >
                        <span>{{ errors[0] }}</span>
                      </div>
                    </BFormGroup>
                  </ValidationProvider>
                </BCol>

                <BCol
                  cols="12"
                  md="4"
                >
                  <ValidationProvider
                    v-slot="{ errors }"
                    vid="password"
                    name="new password"
                    :rules="{
                      required: true,
                      not_equal: 'current_password'
                    }"
                  >
                    <BFormGroup
                      label="New Password"
                      label-for="password"
                      label-class="font-weight-bold"
                      class="mb-2"
                    >
                      <BInputGroup
                        :class="errors.length > 0 ? 'is-invalid' : null"
                      >
                        <BFormInput
                          id="password"
                          v-model="credentials.password"
                          placeholder="enter new password"
                          autocomplete="off"
                          :type="newPasswordType"
                          :state="errors.length > 0 ? false : null"
                          :disabled="state.busy"
                        />
                        <BInputGroupAppend>
                          <BButton
                            class="pl-2 pr-1 text-dark input-icon"
                            variant="warning"
                            :disabled="state.busy"
                            @click.prevent="toggleNewPassword"
                          >
                            <i
                              v-if="state.new_password_visible"
                              class="ri-eye-line h5"
                            />
                            <i
                              v-else
                              class="ri-eye-off-line h5"
                            />
                          </BButton>
                        </BInputGroupAppend>
                      </BInputGroup>
                      <div
                        v-if="errors.length > 0"
                        class="invalid-feedback"
                      >
                        <span>{{ errors[0] }}</span>
                      </div>
                    </BFormGroup>
                  </ValidationProvider>
                </BCol>

                <BCol
                  cols="12"
                  md="4"
                >
                  <ValidationProvider
                    v-slot="{ errors }"
                    name="confirm password"
                    vid="password_confirmation"
                    rules="required|min:8|confirmed:password"
                  >
                    <BFormGroup
                      label="Confirm New Password"
                      label-for="password_confirmation"
                      label-class="font-weight-bold"
                      class="mb-2"
                    >
                      <BInputGroup
                        :class="errors.length > 0 ? 'is-invalid' : null"
                      >
                        <BFormInput
                          id="password_confirmation"
                          v-model="credentials.password_confirmation"
                          placeholder="confirm new password"
                          autocomplete="off"
                          :type="newPasswordType"
                          :state="errors.length > 0 ? false : null"
                          :disabled="state.busy"
                        />
                        <BInputGroupAppend>
                          <BButton
                            class="pl-2 pr-1 text-dark input-icon"
                            variant="warning"
                            :disabled="state.busy"
                            @click.prevent="toggleNewPassword"
                          >
                            <i
                              v-if="state.new_password_visible"
                              class="ri-eye-line h5"
                            />
                            <i
                              v-else
                              class="ri-eye-off-line h5"
                            />
                          </BButton>
                        </BInputGroupAppend>
                      </BInputGroup>
                      <div
                        v-if="errors.length > 0"
                        class="invalid-feedback"
                      >
                        <span>{{ errors[0] }}</span>
                      </div>
                    </BFormGroup>
                  </ValidationProvider>
                </BCol>
              </BRow>

              <div class="d-flex justify-content-end w-100">
                <BButton
                  variant="success"
                  :disabled="state.busy"
                  @click.prevent="onValidateChangePassword"
                >
                  Update Password
                </BButton>
              </div>
            </form>
          </ValidationObserver>
        </BCard>
      </BCol>
    </BRow>
  </BContainer>
</template>

<script>
import { core } from '@/config/pluginInit'

import misc from '@/mixins/misc'

import { SSharedAuth } from '@/services/shared'
export default {
  name: 'SharedChangePassword',

  middleware: ['auth'],

  mixins: [misc],

  metaInfo: () => ({
    title: 'Change Password'
  }),

  data () {
    return {
      state: {
        busy: false,
        current_password_visible: false,
        new_password_visible: false
      },
      credentials: {
        current_password: '',
        password: '',
        password_confirmation: ''
      }
    }
  },

  computed: {

    currentPasswordType () {
      return this.state.current_password_visible ? 'text' : 'password'
    },

    newPasswordType () {
      return this.state.new_password_visible ? 'text' : 'password'
    }

  },

  mounted () {
    core.index()
  },

  methods: {

    toggleCurrentPassword () {
      this.state.current_password_visible = !this.state.current_password_visible
    },

    toggleNewPassword () {
      this.state.new_password_visible = !this.state.new_password_visible
    },

    async onValidateChangePassword (event) {
      event.preventDefault()
      await this.$refs.formChangePassword.validate().then(
        async allFieldsAreValid => {
          if (allFieldsAreValid) {
            this.swalConfirm({
              html: '<h6>Update your Password?</h6>',
              preConfirm: () => {
                this.state.busy = true
                return this.onPostChangePassword()
              }
            })
          } else {
            this.swalInvalid()
          }
        }
      )
    },

    async onPostChangePassword () {
      return new Promise(resolve => {
        SSharedAuth.changePassword(this.credentials).then(
          ({ data: { message } }) => {
            this.swalSuccess(message).then(
              () => {
                this.credentials.current_password = ''
                this.credentials.password = ''
                this.credentials.password_confirmation = ''
                this.$refs.formChangePassword.reset()
              }
            )
          }
        ).catch(
          ({ message }) => {
            this.$refs.formChangePassword.setErrors(message)
            resolve(message)
          }
        ).finally(() => {
          this.state.busy = false
        })
      })
    }
  }

}
</script>
